interface WhitelistBlacklistConfig {
  addressIds?: string[];
  marketIds?: string[];
}

export interface FeatureFlagConfig {
  whitelisted?: WhitelistBlacklistConfig;
  blacklisted?: WhitelistBlacklistConfig;
}

export interface FFAddressIdentifiers {
  addressId: string;
  marketId: string;
}

export enum FlagValue {
  ON = 'on',
  OFF = 'off',
}

export function evaluateSplitFeatureFlag(
  config: FeatureFlagConfig | null,
  userIdentifiers: FFAddressIdentifiers,
): FlagValue {
  if (!config || !userIdentifiers) {
    return FlagValue.OFF; // Or throw an error: "Missing required parameters"
  }

  // Check Address ID
  if (userIdentifiers?.addressId) {
    if (config?.blacklisted?.addressIds?.includes(userIdentifiers.addressId)) {
      return FlagValue.OFF; // Blacklisted address
    }
    if (config?.whitelisted?.addressIds?.includes(userIdentifiers.addressId)) {
      return FlagValue.ON; // Whitelisted address
    }
  }

  // Check Market ID
  if (userIdentifiers?.marketId) {
    if (config?.blacklisted?.marketIds?.includes(userIdentifiers.marketId)) {
      return FlagValue.OFF; // Blacklisted market
    }
    if (config?.whitelisted?.marketIds?.includes(userIdentifiers.marketId)) {
      return FlagValue.ON; // Whitelisted market
    }
  }

  return FlagValue.OFF; // Default OFF if neither address nor market is whitelisted
}
